import { render, staticRenderFns } from "./ProductTraffic.vue?vue&type=template&id=3a732592&scoped=true&"
import script from "./ProductTraffic.vue?vue&type=script&lang=js&"
export * from "./ProductTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a732592",
  null
  
)

export default component.exports